










export default
  props:
    image:
      type: String
      default: ''
    title:
      type: String
      default: ''
    subtitle:
      type: String
      default: ''
